import t from "./index.es220.js";
var p = function p(e) {
    return -e;
  },
  i = function i(e) {
    return Object.entries(e).sort(function (r) {
      return p(r[1]);
    }).map(function (r) {
      return r[0];
    });
  },
  c = function c(e) {
    return {
      "top-left": t.pickerWrapperTopLeft,
      "top-middle": t.pickerWrapperTopMiddle,
      "top-right": t.pickerWrapperTopRight,
      "bottom-left": t.pickerWrapperBottomLeft,
      "bottom-middle": t.pickerWrapperBottomMiddle,
      "bottom-right": t.pickerWrapperBottomRight,
      left: t.pickerWrapperLeft,
      right: t.pickerWrapperRight
    }[e];
  };
export { c as createClassNamePosition, i as getSortedStoredEmojis };